export class DimensionDTO {
    width: number;
    height: number;
    length: number;
    unit: string

    constructor(
        length: number = 0,
        width: number = 0,
        height: number = 0,
        unit: string = "",
    ) {
        this.width = width;
        this.height = height;
        this.length = length;
        this.unit = unit;
    }

    public static copy(destination: DimensionDTO, source: DimensionDTO) : DimensionDTO {
        if (destination.length != source.length) destination.length = source.length;
        if (destination.width != source.width) destination.width = source.width;
        if (destination.height != source.height) destination.height = source.height;
        if (destination.unit != source.unit) destination.unit = source.unit;

        return destination;
    }
}